import {createSvgIcon} from '../create-svg-icon';

export const ChangeHistoryIcon = createSvgIcon(
  <path d="M12 7.77 18.39 18H5.61L12 7.77M12 4 2 20h20L12 4z" />
, 'ChangeHistoryOutlined');
